
export default {
  props: {
    isOnline: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {};
  },

  computed: {
    getColor() {
      return this.isOnline ? "green" : "#F55028";
    }
  },
  mounted() {
    setTimeout(
      (() => {
        this.$emit("hide-store-online-offline-banner");
      }).bind(this),
      4000
    );
  }
};
